import { useEffect } from "react";

interface PageMeta {
  title: string;
  description?: string;
  keywords?: string;
}

const setMetaTag = (name: string, content: string) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setPropertyTag = (property: string, content: string) => {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export const usePageMeta = ({ title, description, keywords }: PageMeta) => {
  useEffect(() => {
    document.title = title;
    setPropertyTag("og:title", title);
    setPropertyTag("og:type", "website");
    setPropertyTag("og:site_name", "秘密影院");

    if (description) {
      setMetaTag("description", description);
      setPropertyTag("og:description", description);
    }
    if (keywords) {
      setMetaTag("keywords", keywords);
    }
  }, [title, description, keywords]);
};